import { isMarketType, getNameOU } from "../../helpers";
export const getSelectionNameAmerican = (props, market, selection) => {
    if (isMarketType(market.marketType.id, "OU") && selection.outcomeType) {
        return getNameOU(selection.outcomeType, props.dict);
    }
    return "";
};
//# sourceMappingURL=getSelectionNameAmerican.js.map